export default __webpack_public_path__ + "static/media/chat.0281c56a.png";